/**
 * option.js
 * 处理radio/checkbox中option的处理函数
 */

/**
 * 为option添加border
 * @param {array} list option
 */
export function cookOptions(list) {
  return list.map(item => {
    item.border = true
    return item
  })
}
/**
 * 根据传参来过滤options
 * @param {array} param0.list option数组
 * @param {function/array/string} param0.condition filter条件，支持多个维度
 */
export function filterOption({ list, condition }) {
  if (!condition) return list
  return list.filter(item => {
    const isHasItem = (array) => {
      return array.map(e => Number(e)).indexOf(item.value || item.id) !== -1
    }
    switch (typeof condition) {
      case 'function':
        return condition(item)
      case 'object':
        if (Array.isArray(condition)) {
          return isHasItem(condition)
        }
        return false
      case 'string':
        return isHasItem(condition.split(','))
      case 'number':
        return condition === (item.value || item.id)
      default:
        return false
    }
  })
}